import { TimeResolution, TrendingProperties } from '@vi-iot/client';

export interface TrendingData {
  devices: {
    deviceId: string;
    boilerSerial: string;
    deviceType: string;
    shortDeviceName: string;
  }[];
  enum_properties?: TrendingEnumMappedProperties;
  enum_series?: TrendingEnumSeriesData[];
  gateway_id: string;
  point_interval: number;
  point_start: number;
  point_end: number;
  resolution?: TimeResolution;
  series: TrendingDataSeries[];
}

export type TrendingEnumMappedProperties = {
  [key in TrendingProperties]: { [key: number]: string };
};

export interface TrendingDataSeries {
  feature: string;
  boilerSerialFeature: string;
  data: number[];
  deviceId: string;
  boilerSerial: string;
  deviceType: string;
  shortDeviceName: string;
}

export interface ChartSelectedProperties {
  chartName: string;
  features: string[];
}

export enum TrendingDateseriesError {
  NoDataWithinRange,
  ErrorDataNotFound502,
  ErrorBigDataError400,
  ErrorConnectionTimeout504,
  Default,
}

export enum TrendingDataseriesErrorType {
  DataNotFound = 'DATA_NOT_FOUND',
  BigDataError = 'BIG_DATA_ERROR',
  ConnectionTimeout = 'CONNECTION_TIMEOUT',
}

export interface TrendingItem {
  feature: string;
  label: string;
  visible: boolean;
  unit?: string;
  max?: number;
  step?: boolean;
  background?: boolean;
}

export enum TrendingChartType {
  Line = 'line',
  Spline = 'spline',
  Column = 'column',
  XRange = 'xrange',
}

export enum TrendingResolution {
  Minute = '1m',
  FiveMinutes = '5m',
  Hour = '1h',
  Day = '1d',
}

export enum TrendingFeatures {
  FourWayCircuitValves = 'heating.primaryCircuit.valves.fourWay/state',
}

export enum TrendingTypeEnum {
  HEATING = 'heating',
  ENERGY_STORAGE = 'energyStorage',
  COMMUNICATION_MODULE = 'communicationModule',
}

export type TrendingType =
  | TrendingTypeEnum.HEATING
  | TrendingTypeEnum.ENERGY_STORAGE
  | TrendingTypeEnum.COMMUNICATION_MODULE;

export interface TrendingTab {
  name: string;
  type: TrendingType;
  isActive: boolean;
  isShow: boolean;
}

export interface EnergyStorageTrendingLabel {
  powerTrendingChartsLabel: TrendingItem[];
  stateOfChargeLabel: TrendingItem[];
  temperaturesLabel: TrendingItem[];
  batteryModuleVoltageLabel: TrendingItem[];
}

export interface TrendingEnumSeriesData {
  feature: string;
  device_id: string;
  value: number[];
  start: number[];
}

export interface VisiblePlotBandFeature {
  chartName: string;
  feature: string;
  visible: boolean;
}
